<template>
	<after-sales type="refund" :after-sales-number="refundNumber" :refund-type="refundType"></after-sales>
</template>

<script>
	import afterSales from './after_sales_detail.vue'
	
	export default {
		name: 'refund_detail',
		
		components: {
			afterSales
		},
		
		props: {
			refundNumber: String,
      refundType: Number
		}
	}
</script>